import Slider from "../components/Slider";
import Service from "../components/Service/indec";
import Parallex from "../components/Parallax";
import WeStrong from "../components/Strong";
import Counter from "../components/Counter";
import ContactUs from "../components/contactus";
import '../assets/css/home.css'
export default function HomePage() {
    return (
        <>
            <Slider />
            <Service />
            <Parallex />
            <WeStrong />
            <Counter />
            <div id="contact" className="contact-us">
                <div className="strong">
                    <span className="wow bounceIn">contact us</span>
                    <h3 className="wow bounceIn">LET&rsquo;S get in touch</h3>
                    <p className="wow bounceIn">Need Something? We're always happy to help.</p>
                </div>
                <ContactUs />
            </div>
        </>
    )
}